module.exports = __webpack_public_path__ + "static/Icon4-0aa3941ab7e9a7c7bf39ba861ebdfc96.svg";